module.exports = __webpack_public_path__ + "img/bg_register_agency.4d1667ef.png";